import { Vue, Component, Prop } from 'vue-property-decorator';
import { isMicroStandardId, getTaxonomyTags } from '@/utils/utils';
import TaxonomyCard from '../taxonomy-card/taxonomy-card';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { appConfigService } from '@/providers/services/app/app-config';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'collection-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'taxonomy-card': TaxonomyCard,
    },
})

export default class CollectionCard extends Vue {
    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private collection: any;

    @Prop({ default: false })
    private isMyContent!: boolean;

    private get tags() {
        return this.collection.standards;
    }

    private get userId() {
        return sessionService.getSession()!.user_id;
    }

    // --------------------------------------------------------------------
    // Actions
    private onPlayCollection(collectionId: string) {
        const playerURL = `${window.location.origin}/library/player/${collectionId}?source=rgo&type=collection`;
        this.$emit('onOpenPlayer', playerURL);
    }

    private editCollections(collectionId: string) {
        const currentRoute = this.$router.currentRoute.path;
        const playerURL = `${window.location.origin}/library/content/collections/edit/${collectionId}?editing=true&redirectUrl=${currentRoute}`;
        window.location.href = playerURL;
    }

    private openPullout() {
        this.$emit('openPullout', this.collection);
    }

    private filterCreator(creator: any) {
        this.$emit('filterCreator', creator);
    }


}
